import React from "react";
import {
  FaUserTie,
  FaStore,
  FaUtensils,
  FaMoneyCheckAlt,
  FaFileInvoiceDollar,
  FaRegIdCard,
  FaIndustry,
  FaAddressCard,
  FaFileContract,
  FaFileSignature,
  FaBalanceScale,
} from "react-icons/fa";
import { Link } from "react-router-dom";

const HomeService = () => {
const services = [
  // {
  //   icon: <FaFileInvoiceDollar size={40} />,
  //   title: "GST Registration Services",
  //   description:
  //     "Get hassle-free GST registration for Individuals, Partnerships, LLPs, and Private Limited Companies. Expert guidance for quick and compliant setup.",
  // },\
            { icon: <FaFileContract size={40} />, title: "Affidavit", description: "Legally sworn statements and declarations." },
              { icon: <FaFileContract size={40} />, title: "Indemnity Bond", description: "Legal protection against potential losses." },
                  { icon: <FaFileSignature size={40} />, title: "All Agreements Between Two Parties", description: "Legally binding agreements between involved parties." },
                  {   icon: <FaBalanceScale size={40} />,
  title: "NOTARY PUBLIC",
  description: "Official legal witnessing and certification of documents.", },

  {
    icon: <FaUtensils size={40} />,
    title: "Food License",
    description:
      "Get your food business licensed quickly with our expert assistance in FSSAI registration.",
  },
  // {
  //   icon: <FaMoneyCheckAlt size={40} />,
  //   title: "Income Tax Returns Filing",
  //   description:
  //     "Expert help in filing accurate ITRs for individuals and businesses to avoid penalties.",
  // },
  {
    icon: <FaStore size={40} />,
    title: "Shop & Establishment License",
    description:
      "Quick licensing for your shop or commercial establishment under state rules.",
  },
  {
    icon: <FaIndustry size={40} />,
    title: "MSME (Udyam Registration)",
    description:
      "Register your micro, small or medium business under Udyam and enjoy government benefits.",
  },
  {
    icon: <FaRegIdCard size={40} />,
    title: "Ayushman Card",
    description:
      "Get your Ayushman Bharat health card to access quality healthcare under government schemes.",
  },
      // { icon: <FaFileContract size={40} />, title: "E-Stamp Paper", description: "Purchase legally valid electronic stamp papers." },


              

          
      
  
];


  return (
<div className="py-16 bg-[#F4F5EF] text-center">
  <h4 className="text-sm tracking-widest text-gray-500 uppercase">
Property Documentations - Registration -Legal -Tax and Business services  
  </h4>

  <h2 className="text-4xl font-serif font-semibold mt-2">
    Expert Assistance Tailored <span className="text-[#b7b7a1]">To</span> Your Business & Personal Needs
  </h2>

  {/* Added description */}
  <p className="max-w-4xl mx-auto mt-6 text-base text-gray-600 leading-relaxed">
    At <span className="font-semibold">CHARETHRI BUSINESS SOLUTIONS</span>, we are committed to providing comprehensive services to meet all your legal and business needs. Whether you require an Affidavit, an Indemnity Bond, or a variety of specialized agreements—including Rental/Lease Agreements and Loan Agreements—we have you covered. Our team is also experienced in facilitating essential documentation such as Notary Public services, Food Licenses, and Shop &amp; Establishment Licenses. Additionally, we assist in MSME Registration to help your business thrive. Trust us to simplify your legal processes and ensure your compliance with all necessary regulations!
  </p>

  <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8 max-w-7xl mx-auto">
    {services.map((service, index) => (
      <div
        key={index}
        className="flex flex-col items-center border-l-2 border-[#b7b7a1] cursor-pointer px-6 py-6 transition-all duration-300 hover:bg-[#b7b7a1]/60 hover:text-white"
      >
        <div className="text-gray-800 mb-4">{service.icon}</div>
        <h3 className="text-xl font-semibold">{service.title}</h3>
        <p className="mt-2 text-sm">{service.description}</p>
      </div>
    ))}
  </div>

  <div className="flex justify-center max-w-8xl">
    <Link to="/services">
      <button className="mt-6 px-6 py-3 bg-[#b7b7a1] text-white text-lg font-semibold rounded-full shadow-md transition hover:bg-[#a0a08b] flex items-center gap-2">
        View All Services <span className="text-xl">↗</span>
      </button>
    </Link>
  </div>
</div>

  );
};

export default HomeService;
